<!-- Activity Logs -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-history"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Activity Logs</h1>
        <p class="page-description">Track all system activities and user actions</p>
      </div>
    </div>
    <div class="header-actions">
      <button class="btn btn-outline-secondary" (click)="viewActivityLogs(currentPage)" [disabled]="loading">
        <i class="fas fa-sync-alt me-1" [class.fa-spin]="loading"></i>
        Refresh
      </button>
      <div class="stats-badge">
        <i class="fas fa-database me-1"></i>
        {{ totalItems }} Total Records
      </div>
    </div>
  </div>
</div>

<!-- Activity Logs Table -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-list-alt"></i>
      </div>
      <div class="title-content">
        <div class="title-text">System Activity Log</div>
        <div class="title-subtitle">Comprehensive audit trail of all system activities</div>
      </div>
    </div>
    <div class="panel-info">
      <div class="info-item" style="display: inline-flex; gap: 4px; font-size: 12px; color: var(--text-tertiary);">
        <span class="info-label">Page:</span>
        <span class="info-value" style="font-weight: 600; color: var(--text-secondary);">{{ currentPage }} of {{ Math.ceil(totalItems / pageSize) || 1 }}</span>
      </div>
    </div>
  </div>

  <div class="panel-body">
    @if (loading) {
      <div class="loading-state">
        <div class="loading-content">
          <div class="loading-spinner">
            <div class="spinner-ring"></div>
          </div>
          <div class="loading-text">
            <h5>Loading Activity Logs</h5>
            <p>Please wait while we fetch the latest system activities...</p>
          </div>
        </div>
      </div>
    } @else {
      <div class="table-container">
        <table class="table align-middle">
          <thead>
            <tr>
              <th>User</th>
              <th>Activity Description</th>
              <th>Date & Time</th>
            </tr>
          </thead>
          <tbody>
            @for (item of activityLogs; track item.created_at) {
              <tr>
                <td>
                  <div style="display: flex; align-items: center; gap: 10px;">
                    <div style="width: 36px; height: 36px; border-radius: 50%; overflow: hidden; flex-shrink: 0; border: 1px solid var(--border);">
                      <img [src]="item.performed_by?.image || '/public/vector.png'"
                           [alt]="item.performed_by?.name || 'System User'"
                           style="width: 100%; height: 100%; object-fit: cover;">
                    </div>
                    <div>
                      <div style="font-size: 13px; font-weight: 600; color: var(--text-primary);">{{ item.performed_by?.name || 'System' }}</div>
                      <div style="font-size: 12px; color: var(--text-tertiary);">{{ item.performed_by?.email || 'system@automated' }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div style="font-size: 13px; color: var(--text-primary);">{{ item.log }}</div>
                  <div style="font-size: 11px; color: var(--text-tertiary); margin-top: 2px;">
                    <span class="badge badge-light badge-sm">System Activity</span>
                  </div>
                </td>
                <td>
                  <div style="font-size: 13px; color: var(--text-primary);" [title]="item.created_at | date:'medium'">
                    {{ item.human_readable_date }}
                  </div>
                  <div style="font-size: 12px; color: var(--text-tertiary);">
                    {{ item.created_at | date:'shortTime' }}
                  </div>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="3">
                  <div class="empty-state">
                    <div class="empty-icon">
                      <i class="fas fa-inbox fa-3x"></i>
                    </div>
                    <div class="empty-content">
                      <h5>No Activity Logs Found</h5>
                      <p>There are currently no activity logs to display. System activities will appear here once they occur.</p>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <!-- Pagination Footer -->
  @if (totalItems > pageSize && !loading) {
    <div class="panel-footer">
      <div class="pagination-info">
        Showing {{ ((currentPage - 1) * pageSize) + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} entries
      </div>
      <ngb-pagination
        [collectionSize]="totalItems"
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [maxSize]="5"
        [rotate]="true"
        [boundaryLinks]="true"
        (pageChange)="onPageChange($event)">
      </ngb-pagination>
    </div>
  }
</div>
